/* eslint-disable camelcase */

export interface RawImageData {
  file_name: string;
  original_file_name: string;
  height: number;
  width: number;
}

export interface RawVideoData {
  file_output: {
    video: { url: string; format: string; quality: string }[];
    image: { url: string; height: number; width: number }[];
  };
  title: string;
}

export interface RawAudioData {
  file_output: {
    audio: { url: string; format: string; quality: string }[];
  };
}

export interface RawFileData {
  original_file_name: string;
  file_name: string;
  media_type: string;
  file_url: string;
  file_output?: {
    video?: { url: string; format: string; quality: string }[];
  };
}
export interface MediaManagerSDKError {
  error_code: number;
  error_description: string;
  error_info: {
    message: string;
    args?: any[]; // eslint-disable-line @typescript-eslint/no-explicit-any
    key: string;
  };
}

export enum MediaManagerUploadErrorTypes {
  SiteQuotaExceeded = 'wpm_error.site_quota_total_storage_exceeded',
  SiteVideoDurationQuotaExceeded = 'wpm_error.site_quota_total_video_duration_exceeded',
  SizeLimitExceeded = 'wpm_error.file_size_exceeded_limit',
  General = 'wpm_error.general',
  MimeTypeMismatch = 'wpm_error.mime_type_mismatch',
  InvalidSession = 'wpm_error.invalid_session',
  SessionExpired = 'wpm_error.session_expired',
  MissingWixSession = 'wpm_error.missing_wix_session',
  IncorrectFileInfo = 'wpm_error.incorrect_file_info',
  InvalidFile = 'wpm_error.invalid_file',
  UnsupportedFileExtension = 'wpm_error.unsupported_file_extension',
  WavInvalidMissingHeader = 'wpm_error.wav_invalid_missing_header',
  WavInvalidFormatChunkMissing = 'wpm_error.wav_invalid_format_chunk_missing',
  ExternalFileAuthorization = 'wpm_error.external_file_authorization',
  ExternalFileForbidden = 'wpm_error.external_file_forbidden',
  UnsupportedImageFormat = 'wpm_error.unsupported_format',
  CorruptedImage = 'wpm_error.corrupted_image',
  ImageDimentionsExceededLimit = 'wpm_error.image_dimentions_exceeded_limit',
  Mp4UnsupportedStereoOnly = 'wpm_error.mp4_unsupported_stereo_only',
  WavUnsupportedStereoOnly = 'wpm_error.wav_unsupported_stereo_only',
  WmaUnsupportedBitrate = 'wpm_error.wma_unsupported_bitrate',
  WmaUnsupportedBitrateLossy = 'wpm_error.wma_unsupported_bitrate_lossy',
  Mp4UnsupportedBitrate = 'wpm_error.mp4_unsupported_bitrate',
  Mp3UnsupportedStereoOnly = 'wpm_error.mp3_unsupported_stereo_only',
  Mp3UnsupportedFormat = 'wpm_error.mp3_unsupported_format',
  WavUnsupportedSampleRate = 'wpm_error.wav_unsupported_sample_rate',
  AacUnsupportedFormat = 'wpm_error.aac_unsupported_format',
  WavUnsupportedFormat = 'wpm_error.wav_unsupported_format',
  WavUnsupportedSampleSize = 'wpm_error.wav_unsupported_sample_size',
  WavUnsupportedFormatChunkSize = 'wpm_error.wav_unsupported_format_chunk_size',
  UnsupportedAudioCodec = 'wpm_error.unsupported_audio_codec',
  ZeroSizeFile = 'wpm_error.zero_size_file',
  Mp4UnsupportedFormat = 'wpm_error.mp4_unsupported_format',
  Mp4UnsupportedSampleRate = 'wpm_error.mp4_unsupported_sample_rate',
  MaxVideoBitrateIsExceeded = 'wpm_error.max_video_bitrate_is_exceeded',
  VideoDurationMismatch = 'wpm_error.video_duration_mismatch',
  UnsupportedVideoCodec = 'wpm_error.unsupported_video_codec',
  SiteSingleVideoDurationQuotaExceeded = 'wpm_error.site_quota_single_video_duration_exceeded',
}
